import InfoTip from '@/components/atoms/InfoTip';

import styles from './SectionTitle.module.scss';

interface SectionTitleProps {
    title: string;
    tooltip?: string;
}

export default function SectionTitle(props: SectionTitleProps) {
    const { title, tooltip } = props;

    return (
        <div className={styles.titleContainer}>
            <div className={styles.title}>{title}</div>
            {tooltip && <InfoTip topic={title} content={tooltip} />}
        </div>
    );
}
